import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "contract_container" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 py-2"
}
const _hoisted_3 = {
  key: 1,
  class: "contract_table_container card-white-6"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加配置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量导入")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_7 = { key: 4 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("添加平台")
const _hoisted_9 = {
  key: 5,
  class: "contract_table_container card-white-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetaProductList = _resolveComponent("MetaProductList")!
  const _component_table_action = _resolveComponent("table-action")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_GsuiteBill = _resolveComponent("GsuiteBill")!
  const _component_AwsBill = _resolveComponent("AwsBill")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_HarborBilling = _resolveComponent("HarborBilling")!
  const _component_MediaRuleConfig = _resolveComponent("MediaRuleConfig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPubLogic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MetaProductList, {
            canEdit: _ctx.canEdit,
            products: _ctx.contract.products,
            entity: _ctx.contract,
            "entity-type": "Contract",
            onUpdateList: _ctx.onUpdateConfig
          }, null, 8, ["canEdit", "products", "entity", "onUpdateList"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGCPBilling)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_we_table, { onRegister: _ctx.register }, {
            action: _withCtx(({ record, column }) => [
              _createVNode(_component_table_action, {
                actions: _ctx.handleActions(record, column)
              }, null, 8, ["actions"])
            ]),
            headerButton: _withCtx(() => [
              _createVNode(_component_a_month_picker, {
                value: _ctx.month,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
                valueFormat: "YYYY-MM"
              }, null, 8, ["value"]),
              _createVNode(_component_a_dropdown, { placement: "bottomCenter" }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, { onClick: _ctx.handleDropClick }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "ByPlainText" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "BatchImportConfig" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_svg_icon, { "icon-name": "DownOutlined" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onRegister"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isGSuiteLogic)
      ? (_openBlock(), _createBlock(_component_GsuiteBill, {
          key: 2,
          isInserted: true,
          contract_id: _ctx.contract.id
        }, null, 8, ["contract_id"]))
      : _createCommentVNode("", true),
    (_ctx.isAwsLogic)
      ? (_openBlock(), _createBlock(_component_AwsBill, {
          key: 3,
          isInserted: true,
          contract_id: _ctx.contract.id
        }, null, 8, ["contract_id"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaLogic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaConfigTableList, (t, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "contract_table_container card-white-6"
            }, [
              _createVNode(_component_we_table, _normalizeProps(_guardReactiveProps(t)), {
                headerButton: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.timeSpanId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeSpanId) = $event)),
                    options: _ctx.timeSpanList
                  }, null, 8, ["value", "options"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.addConfigPlatform
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                action: _withCtx(({ record, column }) => [
                  _createVNode(_component_table_action, {
                    actions: _ctx.handleMediaActions(record, column)
                  }, null, 8, ["actions"])
                ]),
                _: 2
              }, 1040)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMediaLogic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_we_table, _mergeProps(_ctx.accountListTable, {
            dataSource: _ctx.contract.account_list
          }), null, 16, ["dataSource"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPubLogic)
      ? (_openBlock(), _createBlock(_component_HarborBilling, {
          key: 6,
          onUpdateList: _ctx.onUpdateConfig,
          contract_id: _ctx.contract.id,
          contract: _ctx.contract
        }, null, 8, ["onUpdateList", "contract_id", "contract"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MediaRuleConfig, {
      data_item: _ctx.data_item,
      "onUpdate:data_item": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data_item) = $event)),
      title: _ctx.title,
      edit_type: _ctx.edit_type,
      is_demand: _ctx.isDemand,
      is_supply: _ctx.isSupply,
      onOnSave: _ctx.saveRule
    }, null, 8, ["data_item", "title", "edit_type", "is_demand", "is_supply", "onOnSave"])
  ]))
}